module.exports = __webpack_public_path__ + "static/media/select-white.827bfe54.svg";